import { View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';
import { Contract } from '@/types/ContractType';
import Alabama from './Alabama';
import Alaska from './Alaska';
import Arizona from './Arizona';
import Arkansas from './Arkansas';
import California from './California';
import Colorado from './Colorado';
import Connecticut from './Connecticut';
import Delaware from './Delaware';
import DistractofColumbia from './DistractofColumbia';
import Florida from './Florida';
import Georgia from './Georgia';
import Hawaii from './Hawaii';
import Idaho from './Idaho';
import Illinois from './Illinois';
import Indiana from './Indiana';
import Iowa from './Iowa';
import Kansas from './Kansas';
import Kentucky from './Kentucky';
import Louisiana from './Louisiana';
import Maine from './Maine';
import Maryland from './Maryland';
import Massachusetts from './Massachusetts';
import Michigan from './Michigan';
import Minnesota from './Minnesota';
import Mississippi from './Mississippi';
import Missouri from './Missouri';
import Montana from './Montana';
import Nebraska from './Nebraska';
import Nevada from './Nevada';
import NewHampshire from './NewHampshire';
import NewJersey from './NewJersey';
import NewMexico from './NewMexico';
import Ohio from './Ohio';
import Pennsylvania from './Pennsylvania';
import Virginia from './Virginia';

const ContractState = ({ contract }: { contract: Contract }) => {
  return (
    <View style={styles.section}>
      {contract?.agentSellerInfo?.propertyState === 'Alabama' && <Alabama />}
      {contract?.agentSellerInfo?.propertyState === 'Alaska' && <Alaska />}
      {contract?.agentSellerInfo?.propertyState === 'Arizona' && <Arizona />}
      {contract?.agentSellerInfo?.propertyState === 'Arkansas' && <Arkansas />}
      {contract?.agentSellerInfo?.propertyState === 'California' && (
        <California />
      )}
      {contract?.agentSellerInfo?.propertyState === 'Colorado' && <Colorado />}
      {contract?.agentSellerInfo?.propertyState === 'Connecticut' && (
        <Connecticut />
      )}
      {contract?.agentSellerInfo?.propertyState === 'Delaware' && <Delaware />}
      {contract?.agentSellerInfo?.propertyState === 'District of Columbia' && (
        <DistractofColumbia />
      )}
      {contract?.agentSellerInfo?.propertyState === 'Florida' && <Florida />}
      {contract?.agentSellerInfo?.propertyState === 'Georgia' && <Georgia />}
      {contract?.agentSellerInfo?.propertyState === 'Hawaii' && <Hawaii />}
      {contract?.agentSellerInfo?.propertyState === 'Idaho' && <Idaho />}
      {contract?.agentSellerInfo?.propertyState === 'Illinois' && <Illinois />}
      {contract?.agentSellerInfo?.propertyState === 'Indiana' && <Indiana />}
      {contract?.agentSellerInfo?.propertyState === 'Iowa' && <Iowa />}
      {contract?.agentSellerInfo?.propertyState === 'Kansas' && <Kansas />}
      {contract?.agentSellerInfo?.propertyState === 'Kentucky' && <Kentucky />}
      {contract?.agentSellerInfo?.propertyState === 'Louisiana' && (
        <Louisiana />
      )}
      {contract?.agentSellerInfo?.propertyState === 'Maine' && <Maine />}
      {contract?.agentSellerInfo?.propertyState === 'Maryland' && <Maryland />}
      {contract?.agentSellerInfo?.propertyState === 'Massachusetts' && (
        <Massachusetts />
      )}
      {contract?.agentSellerInfo?.propertyState === 'Michigan' && <Michigan />}
      {contract?.agentSellerInfo?.propertyState === 'Minnesota' && (
        <Minnesota />
      )}
      {contract?.agentSellerInfo?.propertyState === 'Mississippi' && (
        <Mississippi />
      )}
      {contract?.agentSellerInfo?.propertyState === 'Missouri' && <Missouri />}
      {contract?.agentSellerInfo?.propertyState === 'Montana' && <Montana />}
      {contract?.agentSellerInfo?.propertyState === 'Nebraska' && <Nebraska />}
      {contract?.agentSellerInfo?.propertyState === 'Nevada' && <Nevada />}
      {contract?.agentSellerInfo?.propertyState === 'New Hampshire' && (
        <NewHampshire />
      )}
      {contract?.agentSellerInfo?.propertyState === 'New Jersey' && (
        <NewJersey />
      )}
      {contract?.agentSellerInfo?.propertyState === 'New Mexico' && (
        <NewMexico />
      )}
      {contract?.agentSellerInfo?.propertyState === 'Ohio' && <Ohio />}
      {contract?.agentSellerInfo?.propertyState === 'Pennsylvania' && (
        <Pennsylvania />
      )}
      {contract?.agentSellerInfo?.propertyState === 'Virginia' && <Virginia />}
    </View>
  );
};

export default ContractState;
